export default {
    "name": "GetPoisWithinRadius",
    "kind": "HoudiniQuery",
    "hash": "43349758ee4680fc4dd69548d14b23476a5ca99677f27a6cbc09bc29f6fb265a",

    "raw": `query GetPoisWithinRadius($input: GetPOIsWithinRadiusInput!) {
  getPoisWithinRadius(input: $input) {
    poiList {
      totalCount
      pageCount
      items {
        ...POIFragment
        __typename
      }
      availabilityStatus {
        code
        availableAccommodationsCount
        totalAccommodationsCount
      }
    }
  }
}

fragment POIFragment on POI {
  ... on BasePOI {
    __typename
    id
    srcPoiId
    name
    address {
      formattedCity
      formattedAddress
      zipCode
      city
      country {
        code
      }
    }
    coordinates {
      lat
      lng
    }
    urlIdentifier
  }
  ... on AccommodationPOI {
    stars
    bookUrl
    priceCategory {
      currency
      count
    }
    startingPrice {
      amount
      currency
    }
    review {
      mention
      score
      count
    }
    images {
      ...ImageFragment
    }
    description
    subType
    facilities
    datasheetId
    isAvailable
    currency
    phone
    id
  }
  ... on AccommodationMichelinPOI {
    images {
      ...ImageFragment
    }
    bookUrl
    priceCategory {
      currency
      count
    }
    description
    review {
      mention
      score
      count
    }
    subType
    facilities
    isAvailable
    startingPrice {
      amount
      currency
    }
    currency
    distinctionStars
    distinctionDescription
    distinctionMillesime
    phone
    id
  }
  ... on ParkingPOI {
    redirectUrl: bookUrl
    splittedAddress {
      firstLine
      secondLine
    }
    id
  }
  ... on RestaurantPOI {
    images {
      ...ImageFragment
    }
    bookUrl
    averagePrice {
      amount
      currency
    }
    review {
      mention
      score
      count
    }
    theForkUrl
    phone
    description
    id
  }
  ... on RestaurantMichelinPOI {
    redirectUrl: bookUrl
    images {
      ...ImageFragment
    }
    distinctionStars
    distinctionDescription
    distinctionMillesime
    bibGourmand
    greenStar
    priceCategory {
      currency
      count
    }
    priceRange {
      min
      max
      currency
    }
    meals {
      cuisineTypes
    }
    description
    facilities
    theForkUrl
    phone
    paymentModes
    id
  }
  ... on TourismPOI {
    redirectUrl: bookUrl
    images {
      ...ImageFragment
    }
    distinctionStars
    distinctionDescription
    distinctionMillesime
    description
    phone
    classificationType
    id
  }
  ... on ServiceGasStationPOI {
    fuels {
      lastUpdatedAt
      prices {
        type
        price {
          amount
          currency
        }
        priceCategory
        filterOptionId
      }
    }
    id
  }
  ... on ServiceEVPOI {
    spots_count
    payment_methods {
      id
      name
    }
    connectors {
      type
      name
      count
      spots {
        power
        count
      }
    }
    id
  }
  ... on ServiceRestStopPOI {
    variant
    fullAddress
    facilities
    isFamilyFriendly
    isVillageEtape
    infoUrl: bookUrl
    id
  }
  ... on PartnerPOI {
    name
    images {
      ...ImageFragment
    }
    description
    datasheetTitle
    bookUrl
    practicalInformations
    practicalInformations2
    practicalInformations3
    callToAction
    address {
      formattedAddress
      formattedCity
      zipCode
      city
      country {
        code
      }
    }
    id
  }
  ... on Partner2POI {
    name
    images {
      ...ImageFragment
    }
    description
    datasheetTitle
    bookUrl
    practicalInformations
    practicalInformations2
    practicalInformations3
    callToAction
    address {
      formattedAddress
      formattedCity
      zipCode
      city
      country {
        code
      }
    }
    id
  }
  __typename
}

fragment ImageFragment on Image {
  copyright
  w160
  w320
  w640
  w960
  w1280
  w1920
  __typename
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getPoisWithinRadius": {
                "type": "GetPoisResult",
                "keyRaw": "getPoisWithinRadius(input: $input)",

                "selection": {
                    "fields": {
                        "poiList": {
                            "type": "PaginatedPOIList",
                            "keyRaw": "poiList",

                            "selection": {
                                "fields": {
                                    "totalCount": {
                                        "type": "Int",
                                        "keyRaw": "totalCount",
                                        "visible": true
                                    },

                                    "pageCount": {
                                        "type": "Int",
                                        "keyRaw": "pageCount",
                                        "visible": true
                                    },

                                    "items": {
                                        "type": "POI",
                                        "keyRaw": "items",

                                        "selection": {
                                            "fields": {
                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            },

                                            "abstractFields": {
                                                "fields": {
                                                    "BasePOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        }
                                                    },

                                                    "AccommodationPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "stars": {
                                                            "type": "Int",
                                                            "keyRaw": "stars",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "bookUrl": {
                                                            "type": "String",
                                                            "keyRaw": "bookUrl",
                                                            "visible": true
                                                        },

                                                        "priceCategory": {
                                                            "type": "PriceCategory",
                                                            "keyRaw": "priceCategory",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "currency": {
                                                                        "type": "Currency",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "startingPrice": {
                                                            "type": "Price",
                                                            "keyRaw": "startingPrice",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "review": {
                                                            "type": "Review",
                                                            "keyRaw": "review",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "mention": {
                                                                        "type": "REVIEW_MENTION",
                                                                        "keyRaw": "mention",
                                                                        "visible": true
                                                                    },

                                                                    "score": {
                                                                        "type": "Float",
                                                                        "keyRaw": "score",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "subType": {
                                                            "type": "SUB_TYPE",
                                                            "keyRaw": "subType",
                                                            "visible": true
                                                        },

                                                        "facilities": {
                                                            "type": "String",
                                                            "keyRaw": "facilities",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "datasheetId": {
                                                            "type": "String",
                                                            "keyRaw": "datasheetId",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "isAvailable": {
                                                            "type": "Boolean",
                                                            "keyRaw": "isAvailable",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        },

                                                        "phone": {
                                                            "type": "String",
                                                            "keyRaw": "phone",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    },

                                                    "AccommodationMichelinPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "bookUrl": {
                                                            "type": "String",
                                                            "keyRaw": "bookUrl",
                                                            "visible": true
                                                        },

                                                        "priceCategory": {
                                                            "type": "PriceCategory",
                                                            "keyRaw": "priceCategory",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "currency": {
                                                                        "type": "Currency",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "review": {
                                                            "type": "Review",
                                                            "keyRaw": "review",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "mention": {
                                                                        "type": "REVIEW_MENTION",
                                                                        "keyRaw": "mention",
                                                                        "visible": true
                                                                    },

                                                                    "score": {
                                                                        "type": "Float",
                                                                        "keyRaw": "score",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "subType": {
                                                            "type": "SUB_TYPE",
                                                            "keyRaw": "subType",
                                                            "visible": true
                                                        },

                                                        "facilities": {
                                                            "type": "String",
                                                            "keyRaw": "facilities",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "isAvailable": {
                                                            "type": "Boolean",
                                                            "keyRaw": "isAvailable",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "startingPrice": {
                                                            "type": "Price",
                                                            "keyRaw": "startingPrice",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "currency": {
                                                            "type": "String",
                                                            "keyRaw": "currency",
                                                            "visible": true
                                                        },

                                                        "distinctionStars": {
                                                            "type": "Int",
                                                            "keyRaw": "distinctionStars",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "distinctionDescription": {
                                                            "type": "String",
                                                            "keyRaw": "distinctionDescription",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "distinctionMillesime": {
                                                            "type": "Int",
                                                            "keyRaw": "distinctionMillesime",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "phone": {
                                                            "type": "String",
                                                            "keyRaw": "phone",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    },

                                                    "ParkingPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "redirectUrl": {
                                                            "type": "String",
                                                            "keyRaw": "redirectUrl",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "splittedAddress": {
                                                            "type": "SplittedAddress",
                                                            "keyRaw": "splittedAddress",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "firstLine": {
                                                                        "type": "String",
                                                                        "keyRaw": "firstLine",
                                                                        "visible": true
                                                                    },

                                                                    "secondLine": {
                                                                        "type": "String",
                                                                        "keyRaw": "secondLine",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    },

                                                    "RestaurantPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "bookUrl": {
                                                            "type": "String",
                                                            "keyRaw": "bookUrl",
                                                            "visible": true
                                                        },

                                                        "averagePrice": {
                                                            "type": "Price",
                                                            "keyRaw": "averagePrice",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "amount": {
                                                                        "type": "Float",
                                                                        "keyRaw": "amount",
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "review": {
                                                            "type": "Review",
                                                            "keyRaw": "review",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "mention": {
                                                                        "type": "REVIEW_MENTION",
                                                                        "keyRaw": "mention",
                                                                        "visible": true
                                                                    },

                                                                    "score": {
                                                                        "type": "Float",
                                                                        "keyRaw": "score",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "theForkUrl": {
                                                            "type": "String",
                                                            "keyRaw": "theForkUrl",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "phone": {
                                                            "type": "String",
                                                            "keyRaw": "phone",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    },

                                                    "RestaurantMichelinPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "redirectUrl": {
                                                            "type": "String",
                                                            "keyRaw": "redirectUrl",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "distinctionStars": {
                                                            "type": "Int",
                                                            "keyRaw": "distinctionStars",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "distinctionDescription": {
                                                            "type": "String",
                                                            "keyRaw": "distinctionDescription",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "distinctionMillesime": {
                                                            "type": "Int",
                                                            "keyRaw": "distinctionMillesime",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "bibGourmand": {
                                                            "type": "Boolean",
                                                            "keyRaw": "bibGourmand",
                                                            "visible": true
                                                        },

                                                        "greenStar": {
                                                            "type": "Boolean",
                                                            "keyRaw": "greenStar",
                                                            "visible": true
                                                        },

                                                        "priceCategory": {
                                                            "type": "PriceCategory",
                                                            "keyRaw": "priceCategory",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "currency": {
                                                                        "type": "Currency",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "priceRange": {
                                                            "type": "PriceRange",
                                                            "keyRaw": "priceRange",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "min": {
                                                                        "type": "Float",
                                                                        "keyRaw": "min",
                                                                        "visible": true
                                                                    },

                                                                    "max": {
                                                                        "type": "Float",
                                                                        "keyRaw": "max",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "currency": {
                                                                        "type": "String",
                                                                        "keyRaw": "currency",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "meals": {
                                                            "type": "Meals",
                                                            "keyRaw": "meals",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "cuisineTypes": {
                                                                        "type": "String",
                                                                        "keyRaw": "cuisineTypes",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "facilities": {
                                                            "type": "String",
                                                            "keyRaw": "facilities",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "theForkUrl": {
                                                            "type": "String",
                                                            "keyRaw": "theForkUrl",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "phone": {
                                                            "type": "String",
                                                            "keyRaw": "phone",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "paymentModes": {
                                                            "type": "String",
                                                            "keyRaw": "paymentModes",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    },

                                                    "TourismPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "redirectUrl": {
                                                            "type": "String",
                                                            "keyRaw": "redirectUrl",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "distinctionStars": {
                                                            "type": "Int",
                                                            "keyRaw": "distinctionStars",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "distinctionDescription": {
                                                            "type": "String",
                                                            "keyRaw": "distinctionDescription",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "distinctionMillesime": {
                                                            "type": "Int",
                                                            "keyRaw": "distinctionMillesime",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "phone": {
                                                            "type": "String",
                                                            "keyRaw": "phone",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "classificationType": {
                                                            "type": "String",
                                                            "keyRaw": "classificationType",
                                                            "visible": true
                                                        }
                                                    },

                                                    "ServiceGasStationPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "fuels": {
                                                            "type": "Fuels",
                                                            "keyRaw": "fuels",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "lastUpdatedAt": {
                                                                        "type": "String",
                                                                        "keyRaw": "lastUpdatedAt",
                                                                        "visible": true
                                                                    },

                                                                    "prices": {
                                                                        "type": "FuelPrice",
                                                                        "keyRaw": "prices",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "type": {
                                                                                    "type": "FUEL_TYPE",
                                                                                    "keyRaw": "type",
                                                                                    "visible": true
                                                                                },

                                                                                "price": {
                                                                                    "type": "Price",
                                                                                    "keyRaw": "price",

                                                                                    "selection": {
                                                                                        "fields": {
                                                                                            "amount": {
                                                                                                "type": "Float",
                                                                                                "keyRaw": "amount",
                                                                                                "visible": true
                                                                                            },

                                                                                            "currency": {
                                                                                                "type": "String",
                                                                                                "keyRaw": "currency",
                                                                                                "visible": true
                                                                                            }
                                                                                        }
                                                                                    },

                                                                                    "visible": true
                                                                                },

                                                                                "priceCategory": {
                                                                                    "type": "PRICE_CATEGORY",
                                                                                    "keyRaw": "priceCategory",
                                                                                    "nullable": true,
                                                                                    "visible": true
                                                                                },

                                                                                "filterOptionId": {
                                                                                    "type": "OptionId",
                                                                                    "keyRaw": "filterOptionId",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    },

                                                    "ServiceEVPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "spots_count": {
                                                            "type": "Int",
                                                            "keyRaw": "spots_count",
                                                            "visible": true
                                                        },

                                                        "payment_methods": {
                                                            "type": "EVPaymentMethod",
                                                            "keyRaw": "payment_methods",

                                                            "selection": {
                                                                "fields": {
                                                                    "id": {
                                                                        "type": "EVPaymentMethodId",
                                                                        "keyRaw": "id",
                                                                        "visible": true
                                                                    },

                                                                    "name": {
                                                                        "type": "String",
                                                                        "keyRaw": "name",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "connectors": {
                                                            "type": "Connector",
                                                            "keyRaw": "connectors",

                                                            "selection": {
                                                                "fields": {
                                                                    "type": {
                                                                        "type": "ConnectorType",
                                                                        "keyRaw": "type",
                                                                        "visible": true
                                                                    },

                                                                    "name": {
                                                                        "type": "String",
                                                                        "keyRaw": "name",
                                                                        "visible": true
                                                                    },

                                                                    "count": {
                                                                        "type": "Int",
                                                                        "keyRaw": "count",
                                                                        "visible": true
                                                                    },

                                                                    "spots": {
                                                                        "type": "Spot",
                                                                        "keyRaw": "spots",

                                                                        "selection": {
                                                                            "fields": {
                                                                                "power": {
                                                                                    "type": "Int",
                                                                                    "keyRaw": "power",
                                                                                    "visible": true
                                                                                },

                                                                                "count": {
                                                                                    "type": "Int",
                                                                                    "keyRaw": "count",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        }
                                                    },

                                                    "ServiceRestStopPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "variant": {
                                                            "type": "REST_STOP_VARIANT",
                                                            "keyRaw": "variant",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "fullAddress": {
                                                            "type": "String",
                                                            "keyRaw": "fullAddress",
                                                            "visible": true
                                                        },

                                                        "facilities": {
                                                            "type": "String",
                                                            "keyRaw": "facilities",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "isFamilyFriendly": {
                                                            "type": "Boolean",
                                                            "keyRaw": "isFamilyFriendly",
                                                            "visible": true
                                                        },

                                                        "isVillageEtape": {
                                                            "type": "Boolean",
                                                            "keyRaw": "isVillageEtape",
                                                            "visible": true
                                                        },

                                                        "infoUrl": {
                                                            "type": "String",
                                                            "keyRaw": "infoUrl",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    },

                                                    "PartnerPOI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "datasheetTitle": {
                                                            "type": "String",
                                                            "keyRaw": "datasheetTitle",
                                                            "visible": true
                                                        },

                                                        "bookUrl": {
                                                            "type": "String",
                                                            "keyRaw": "bookUrl",
                                                            "visible": true
                                                        },

                                                        "practicalInformations": {
                                                            "type": "String",
                                                            "keyRaw": "practicalInformations",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "practicalInformations2": {
                                                            "type": "String",
                                                            "keyRaw": "practicalInformations2",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "practicalInformations3": {
                                                            "type": "String",
                                                            "keyRaw": "practicalInformations3",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "callToAction": {
                                                            "type": "String",
                                                            "keyRaw": "callToAction",
                                                            "visible": true
                                                        }
                                                    },

                                                    "Partner2POI": {
                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        },

                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true
                                                        },

                                                        "srcPoiId": {
                                                            "type": "String",
                                                            "keyRaw": "srcPoiId",
                                                            "visible": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "visible": true
                                                        },

                                                        "address": {
                                                            "type": "Address",
                                                            "keyRaw": "address",

                                                            "selection": {
                                                                "fields": {
                                                                    "formattedCity": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedCity",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "formattedAddress": {
                                                                        "type": "String",
                                                                        "keyRaw": "formattedAddress",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "zipCode": {
                                                                        "type": "String",
                                                                        "keyRaw": "zipCode",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "city": {
                                                                        "type": "String",
                                                                        "keyRaw": "city",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "country": {
                                                                        "type": "Country",
                                                                        "keyRaw": "country",
                                                                        "nullable": true,

                                                                        "selection": {
                                                                            "fields": {
                                                                                "code": {
                                                                                    "type": "String",
                                                                                    "keyRaw": "code",
                                                                                    "visible": true
                                                                                }
                                                                            }
                                                                        },

                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "coordinates": {
                                                            "type": "Coordinates",
                                                            "keyRaw": "coordinates",

                                                            "selection": {
                                                                "fields": {
                                                                    "lat": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lat",
                                                                        "visible": true
                                                                    },

                                                                    "lng": {
                                                                        "type": "Float",
                                                                        "keyRaw": "lng",
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "urlIdentifier": {
                                                            "type": "String",
                                                            "keyRaw": "urlIdentifier",
                                                            "visible": true
                                                        },

                                                        "images": {
                                                            "type": "Image",
                                                            "keyRaw": "images",

                                                            "selection": {
                                                                "fields": {
                                                                    "copyright": {
                                                                        "type": "String",
                                                                        "keyRaw": "copyright",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "w160": {
                                                                        "type": "String",
                                                                        "keyRaw": "w160",
                                                                        "visible": true
                                                                    },

                                                                    "w320": {
                                                                        "type": "String",
                                                                        "keyRaw": "w320",
                                                                        "visible": true
                                                                    },

                                                                    "w640": {
                                                                        "type": "String",
                                                                        "keyRaw": "w640",
                                                                        "visible": true
                                                                    },

                                                                    "w960": {
                                                                        "type": "String",
                                                                        "keyRaw": "w960",
                                                                        "visible": true
                                                                    },

                                                                    "w1280": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1280",
                                                                        "visible": true
                                                                    },

                                                                    "w1920": {
                                                                        "type": "String",
                                                                        "keyRaw": "w1920",
                                                                        "visible": true
                                                                    },

                                                                    "__typename": {
                                                                        "type": "String",
                                                                        "keyRaw": "__typename",
                                                                        "visible": true
                                                                    }
                                                                },

                                                                "fragments": {
                                                                    "ImageFragment": {
                                                                        "arguments": {}
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "description": {
                                                            "type": "String",
                                                            "keyRaw": "description",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "datasheetTitle": {
                                                            "type": "String",
                                                            "keyRaw": "datasheetTitle",
                                                            "visible": true
                                                        },

                                                        "bookUrl": {
                                                            "type": "String",
                                                            "keyRaw": "bookUrl",
                                                            "visible": true
                                                        },

                                                        "practicalInformations": {
                                                            "type": "String",
                                                            "keyRaw": "practicalInformations",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "practicalInformations2": {
                                                            "type": "String",
                                                            "keyRaw": "practicalInformations2",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "practicalInformations3": {
                                                            "type": "String",
                                                            "keyRaw": "practicalInformations3",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "callToAction": {
                                                            "type": "String",
                                                            "keyRaw": "callToAction",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "typeMap": {
                                                    "ServicePOI": "BasePOI"
                                                }
                                            },

                                            "fragments": {
                                                "POIFragment": {
                                                    "arguments": {}
                                                }
                                            }
                                        },

                                        "abstract": true,
                                        "visible": true
                                    },

                                    "availabilityStatus": {
                                        "type": "AvailabilityStatus",
                                        "keyRaw": "availabilityStatus",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "code": {
                                                    "type": "AvailabilityStatusCode",
                                                    "keyRaw": "code",
                                                    "visible": true
                                                },

                                                "availableAccommodationsCount": {
                                                    "type": "Int",
                                                    "keyRaw": "availableAccommodationsCount",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "totalAccommodationsCount": {
                                                    "type": "Int",
                                                    "keyRaw": "totalAccommodationsCount",
                                                    "nullable": true,
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetPOIsWithinRadiusInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "PoiFiltersInput": {
                "id": "PoiFilterId",
                "value": "FilterObject"
            },

            "GetPOIsWithinRadiusInput": {
                "center": "CoordinatesInput",
                "page": "Int",
                "perPage": "Int",
                "platform": "BookingPlatform",
                "poiFilters": "PoiFiltersInput",
                "radius": "Int",
                "types": "POI_TYPE_QUERY"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=ae924982118035f1d5c810a694850c5de239eba72eb1b512bf4a86a43438ae5a";